export function map(value, min1, max1, min2, max2, clampResult) {
	var returnvalue = ((value - min1) / (max1 - min1)) * (max2 - min2) + min2
	return returnvalue
}

export function clamp(value, min, max) {
	return Math.max(min, Math.min(max, value))
}
